import React, { useState } from "react";

export default function GroupManagement() {
  const [groups, setGroups] = useState([]);
  const [newGroupName, setNewGroupName] = useState("");
  const [csvFile, setCsvFile] = useState(null);

  const handleCreateGroup = (e) => {
    e.preventDefault();
    if (!newGroupName.trim()) return;
    setGroups((prev) => [...prev, { name: newGroupName, managers: [] }]);
    setNewGroupName("");
  };

  const handleCsvUpload = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
    alert("Bulk CSV upload coming soon.");
  };

  return (
    <div className="space-y-8">
      <h2 className="text-xl font-bold">Group Management</h2>

      {/* Create Group */}
      <form onSubmit={handleCreateGroup} className="bg-white p-4 rounded shadow border max-w-md space-y-4">
        <h3 className="text-lg font-semibold">Create Group</h3>
        <input
          type="text"
          placeholder="Group Name"
          value={newGroupName}
          onChange={(e) => setNewGroupName(e.target.value)}
          className="border px-3 py-2 rounded w-full"
        />
        <button type="submit" className="bg-gray-800 text-white px-4 py-2 rounded">
          Add Group
        </button>
      </form>

      {/* Bulk Upload */}
      <div className="bg-white p-4 rounded shadow border max-w-md">
        <h3 className="text-lg font-semibold mb-2">Bulk Upload Groups</h3>
        <input type="file" accept=".csv" onChange={handleCsvUpload} />
        <p className="text-sm text-gray-500 mt-2">
          CSV Template: Group Name, Manager Email (optional)
        </p>
        <a href="/group-template.csv" download className="text-blue-600 text-sm underline mt-2 inline-block">
          Download Template
        </a>
      </div>

      {/* Group Table */}
      <div className="bg-white p-4 rounded shadow border">
        <h3 className="text-lg font-semibold mb-2">Groups</h3>
        {groups.length === 0 ? (
          <p className="text-sm text-gray-500">No groups created yet.</p>
        ) : (
          <table className="w-full text-sm border-t">
            <thead>
              <tr className="text-left border-b">
                <th className="py-2">Group</th>
                <th className="py-2">Managers</th>
              </tr>
            </thead>
            <tbody>
              {groups.map((group, idx) => (
                <tr key={idx} className="border-b">
                  <td className="py-2">{group.name}</td>
                  <td className="py-2 text-gray-600">{group.managers.join(", ") || "None assigned"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
